import React, { useMemo } from 'react';
import { Truck, RefreshCw, ShieldCheck, Sparkles, Leaf } from 'lucide-react';
import { useSettings } from '../contexts/SettingsContext';

const iconMap: Record<string, React.ComponentType<any>> = {
  Truck,
  RefreshCw,
  ShieldCheck,
  Sparkles,
  Leaf,
};

export const TrustBadges: React.FC = () => {
  const { settings } = useSettings();

  const badges = useMemo(() => {
    if (settings?.highlights && settings.highlights.length > 0) {
      return settings.highlights.map((item, idx) => ({
        title: item.title,
        description: item.description,
        icon: iconMap[item.icon || 'Sparkles'] || Sparkles,
        key: `${item.title}-${idx}`,
      }));
    }
    return [
      { icon: Truck, title: 'Pan-India Delivery', description: 'Ships to 26k+ pincodes', key: 'delivery' },
      { icon: RefreshCw, title: 'Easy Free Returns', description: 'Hassle-free 7 day window', key: 'returns' },
      { icon: ShieldCheck, title: 'Authentic Quality', description: 'Trusted by thousands', key: 'quality' },
    ];
  }, [settings?.highlights]);

  return (
    <section className="relative bg-secondary/75 py-14">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-10">
          <p className="text-sm font-semibold uppercase tracking-[0.24em] text-primary/75">Silver Strix Promise</p>
          <h2 className="mt-2 text-3xl font-extrabold text-text md:text-4xl">
            What you can count on
          </h2>
          <p className="mt-2 text-sm text-charcoal/75 md:text-base">Every order, every time.</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {badges.map((badge) => {
            const Icon = badge.icon as React.ComponentType<any>;
            return (
              <div
                key={badge.key}
                className="group rounded-[24px] border border-primary/10 bg-white/75 px-5 py-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_18px_40px_rgba(13,13,13,0.08)]"
              >
                <div className="flex items-start gap-4">
                  <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary/8 text-primary transition-colors duration-300 group-hover:bg-primary group-hover:text-white">
                    <Icon size={22} />
                  </div>
                  <div>
                    <h3 className="mb-1 text-lg font-semibold text-text">{badge.title}</h3>
                    {badge.description && <p className="text-sm leading-relaxed text-charcoal/75">{badge.description}</p>}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
